import React, { forwardRef } from "react";

import Styles from "./Select.styles";
import { SelectProps as Props } from "./Select.types";

const Select = forwardRef<HTMLSelectElement, Props>((props, ref) => {
  const { disabled, className, label, selectData, ...rest1 } = props;
  const { description, errorMessage, placeholder, ...rest2 } = rest1;

  return (
    <Styles className={`Select ${className}`}>
      <p className={`Select__label`}>{label}</p>
      <select
        className="Select__dropdown"
        ref={ref}
        {...rest2}
        disabled={disabled}
      >
        <option value="" key="" disabled className="Select__option">
          {placeholder}
        </option>
        {selectData.map(data => (
          <option key={data.key} value={data.key} className="Select__option">
            {data.value}
          </option>
        ))}
      </select>
      {description ? (
        <p className="Select__description">{description}</p>
      ) : null}
      {errorMessage ? <p className="Select__error">{errorMessage}</p> : null}
    </Styles>
  );
});

Select.defaultProps = {};
Select.displayName = "Select";

export default Select;
